var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('button',{on:{"click":function($event){return _vm.submit()}}},[_vm._v("高考模拟")])])}
var staticRenderFns = []

export { render, staticRenderFns }